<ng-container *ngIf="isPageLoading; else pageContent">
    <div class="skeleton-card" *ngFor="let i of [1,2,3,4]">
        <div class="skeleton-header"></div>
        <div class="skeleton-row"></div>
        <div class="skeleton-row short"></div>
        <div class="skeleton-row"></div>
    </div>
</ng-container>

<ng-template #pageContent>
    <div *ngIf="coursePayload">
        <div class="page-container">
            <div class="course-preview-header">
                <div class="header-row">
                    <div class="header-text">
                        <div class="top-line">
                            <i class="bi bi-arrow-left-short" (click)="goBack()"></i>
                            <h3 class="course-heading">Course Preview</h3>
                        </div>
                        <p class="sub-head">Review all course details before publishing</p>
                    </div>

                    <div class="button-group">
                        <button class="btn btn-back" *ngIf="!courseId" (click)="goBackToPreviousStep()">
                            <i class="bi bi-arrow-left"></i> Back
                        </button>

						<ng-container *hasPermission="PermissionForStudents.COURSE_UPDATE">
                        <button class="btn btn-publish" *ngIf="courseId && status === courseStatus.Draft"
                            [disabled]="isLoadingDraft || isLoadingPublish" (click)="publishCourse()">
                            Publish
                        </button>
						</ng-container>

                        <!-- <button class="btn btn-draft" *ngIf="courseId && status === courseStatus.Published"
                            [disabled]="isLoadingDraft || isLoadingPublish" (click)="saveAsDraft()">
                            Save Draft
                        </button> -->
                    </div>
                </div>

                <div class="divider"></div>
            </div>

            <div *ngIf="coursePayload">

                <div class="course-details-card" [formGroup]="editCourseForm">

                    <!-- EDIT BUTTON (Visible only in Draft) -->
					 <ng-container *hasPermission="PermissionForStudents.COURSE_UPDATE">
                    <div class="edit-btn" *ngIf="status === courseStatus.Draft && !isEditing" (click)="editCourse()">
                        <i class="bi bi-pencil-square"></i> Edit
                    </div>
					</ng-container>

                    <!-- SAVE + CANCEL BUTTONS -->
                    <div class="edit-btn" *ngIf="isEditing" style="right: 8rem;" (click)="saveCourse()">
                        <i class="bi bi-check2-circle"></i> Save
                    </div>

                    <div class="edit-btn" *ngIf="isEditing" style="right: 2rem; background:#ffe7e7; color:#c40000;"
                        (click)="cancelEdit()">
                        <i class="bi bi-x-circle"></i> Cancel
                    </div>
                    <div class="course-details-header">
                        <div class="course-details-icon">
                            <i class="bi bi-mortarboard-fill"></i>
                        </div>
                        <div class="course-details-title">
                            Course Details
                            <div class="course-details-subtitle">Basic information</div>
                        </div>
                    </div>

                    <div class="course-details-content">

                        <div class="course-details-col full-width">
                            <div *ngIf="!isEditing">
                                <div class="thumbnail-preview-wrapper"
                                    *ngIf="coursePayload.course_thumbnail; else noThumb">
                                    <div class="thumbnail-box">
                                        <img [src]="getThumbnailSrc()" class="course-thumbnail-img" />
                                    </div>
                                </div>
                                <ng-template #noThumb>
                                    <p class="text-muted">No thumbnail available</p>
                                </ng-template>
                            </div>
                            <!-- EDIT MODE -->
                            <div *ngIf="isEditing">

                                <label class="thumbnail-label">Course Thumbnail</label>

                                <div class="upload-box" (click)="fileInput.click()" (dragover)="onDragOver($event)"
                                    (dragleave)="onDragLeave()" (drop)="onFileDrop($event)"
                                    [class.dragging]="isDragging">

                                    <input type="file" #fileInput accept="image/png,image/jpeg" hidden
                                        (change)="onFileSelect($event)" />

                                    <div class="upload-content">
                                        <div class="upload-icon">⬆️</div>
                                        <p class="upload-title">Click to upload or drag and drop</p>
                                        <p class="upload-subtitle">PNG, JPG up to 5MB</p>
                                        <p class="file-name"
                                            *ngIf="selectedThumbnailFile || coursePayload.course_thumbnail">
                                            {{ getThumbnailFileName() }}
                                        </p>

                                    </div>
                                </div>
                                <!-- Preview selected OR existing thumbnail -->
                                <div class="thumbnail-preview-wrapper"
                                    *ngIf="previewThumbnail || coursePayload.course_thumbnail">
                                    <div class="thumbnail-box">
                                        <img [src]="previewThumbnail || getThumbnailSrc()"
                                            class="course-thumbnail-img" />
                                    </div>

                                    <button class="remove-thumb-btn" (click)="removeSelectedThumbnail()">

                                        <i class="bi bi-trash"></i> Remove
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="course-details-row">
                            <div class="course-details-col">
                                <div class="course-details-label">COURSE TITLE</div>

                                <div *ngIf="!isEditing">{{ coursePayload.course_title }}</div>

                                <div *ngIf="isEditing">
                                    <input class="edit-input" formControlName="course_title" />

                                    <small class="text-danger" *ngIf="editCourseForm.get('course_title')?.touched &&
                        editCourseForm.get('course_title')?.invalid">
                                        Title is required (max 80 chars)
                                    </small>
                                </div>
                            </div>

                            <div class="course-details-col">
                                <div class="course-details-label">COURSE CODE</div>

                                <div *ngIf="!isEditing">{{ coursePayload.course_code }}</div>

                                <div *ngIf="isEditing">
                                    <input class="edit-input" formControlName="course_code" />

                                    <small class="text-danger" *ngIf="editCourseForm.get('course_code')?.touched &&
                        editCourseForm.get('course_code')?.invalid">
                                        Only letters, numbers, _ and - allowed
                                    </small>
                                </div>
                            </div>

                            <div class="course-details-col">
                                <div class="course-details-label">GRADE</div>

                                <div *ngIf="!isEditing">
                                    {{ coursePayload.grade_level }}
                                </div>
                                <div *ngIf="isEditing">
                                    <select class="edit-input" formControlName="grade_level">
                                        <option value="" disabled>Select Grade</option>
                                        <option value="Beginner">Beginner</option>
                                        <option value="Intermediate">Intermediate</option>
                                        <option value="Advanced">Advanced</option>
                                    </select>

                                    <small class="text-danger" *ngIf="editCourseForm.get('grade_level')?.touched &&
                  editCourseForm.get('grade_level')?.invalid">
                                        Grade is required
                                    </small>
                                </div>
                            </div>
                        </div>

                        <div class="course-details-row">

                            <div class="course-details-col">
                                <div class="course-details-label">RATING</div>

                                <div *ngIf="!isEditing">{{ coursePayload.rating || '--' }}</div>

                                <div *ngIf="isEditing">
                                    <input type="number" class="edit-input" formControlName="rating" min="1" max="5"
                                        value="" />

                                    <small class="text-danger" *ngIf="editCourseForm.get('rating')?.touched &&
         editCourseForm.get('rating')?.value &&
         editCourseForm.get('rating')?.invalid">
                                        Rating must be between 1 and 5
                                    </small>

                                </div>
                            </div>
                        </div>

                        <div class="course-details-row">
                            <div class="course-details-col">
                                <div class="course-details-label">DESCRIPTION</div>
                                <div *ngIf="!isEditing" [innerHTML]="coursePayload.course_description || '-'"></div>

                                <div *ngIf="isEditing">
                                    <textarea class="edit-textarea" rows="4"
                                        formControlName="course_description"></textarea>

                                    <small class="text-danger" *ngIf="editCourseForm.get('course_description')?.touched &&
                        editCourseForm.get('course_description')?.invalid">
                                        Description is required (max 280 chars)
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="course-details-card" [formGroup]="editCourseForm">

                    <!-- EDIT BUTTON -->
					<ng-container *hasPermission="PermissionForStudents.COURSE_UPDATE">
                    <div class="edit-btn" *ngIf="status === courseStatus.Draft && !isEditingObjectives"
                        (click)="startObjectivesEdit()">
                        <i class="bi bi-pencil-square"></i> Edit
                    </div>
					</ng-container>

                    <!-- SAVE BUTTON -->
                    <div class="edit-btn" *ngIf="isEditingObjectives" style="right: 8rem;"
                       (click)="saveObjectives()">
                        <i class="bi bi-check2-circle"></i> Save
                    </div>

                    <!-- CANCEL BUTTON -->
                    <div class="edit-btn" *ngIf="isEditingObjectives"
                        style="right: 2rem; background:#ffe7e7; color:#c40000;" (click)="cancelObjectivesEdit()">
                        <i class="bi bi-x-circle"></i> Cancel
                    </div>
                    <div class="course-details-header">
                        <div class="course-details-icon"><i class="bi bi-bullseye"></i></div>
                        <div class="course-details-title">Course Objectives</div>
                    </div>

                    <div class="course-details-content">
                        <!-- VIEW MODE -->
                        <ul *ngIf="!isEditingObjectives && coursePayload.course_objectives?.length; else noObj">
                            <li *ngFor="let obj of coursePayload.course_objectives">{{ obj }}</li>
                        </ul>
                        <ng-template #noObj>
                            <p class="text-muted text-center" *ngIf="!isEditingObjectives">
                                No objectives added
                            </p>
                        </ng-template>

                        <!-- EDIT MODE -->
                        <div *ngIf="isEditingObjectives">
                            <label class="edit-label">Edit Objectives</label>

                            <textarea formControlName="course_objectives" class="edit-textarea" rows="6"
                                placeholder="Enter one objective per line"></textarea>

                            <small class="text-danger" *ngIf="editCourseForm.get('course_objectives')?.touched &&
                    editCourseForm.get('course_objectives')?.invalid">
                                Enter at least 1 valid objective.
                            </small>
                        </div>
                    </div>
                </div>

                <!-- MODULES -->
                <div class="course-details-card">

                    <!-- ACTION BUTTONS (MATCHING OBJECTIVES CARD) -->
                    <div class="details-actions">

                        <!-- EDIT -->
						<ng-container *hasPermission="PermissionForStudents.COURSE_UPDATE">
                        <button class="action-btn edit" *ngIf="status === courseStatus.Draft && !isEditingUnits"
                            (click)="isEditingUnits = true">
                            <i class="bi bi-pencil-square"></i>
                            Edit
                        </button>
						</ng-container>

                        <!-- SAVE -->
                        <!-- <button class="action-btn save" *ngIf="isEditingUnits" [disabled]="!canSaveUnits"
                            (click)="saveUnitsSection()">
                            <i class="bi bi-check2-circle"></i>
                            Save
                        </button> -->

                        <!-- CANCEL -->
                        <!-- <button class="action-btn cancel" *ngIf="isEditingUnits" (click)="cancelUnitsEdit()">
                            <i class="bi bi-x-circle"></i>
                            Cancel
                        </button> -->

                    </div>
                    <!-- HEADER -->
                    <div class="course-details-header">
                        <div class="course-details-icon"><i class="bi bi-book"></i></div>
                        <div class="course-details-title">Modules & Lessons</div>
                    </div>

                    <div class="course-details-content">
                        <div *ngIf="!isEditingUnits">
                            <div class="unit-card" *ngFor="let unit of coursePayload.units; let u = index">
                                <!-- UNIT HEADER -->
                                <div class="unit-header" (click)="unit.expanded = !unit.expanded">

                                    <div class="unit-title-left">
                                        <i class="bi"
                                            [ngClass]="unit.expanded ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
                                        <strong>{{ unit.unit_title }}</strong>
                                    </div>

                                    <div class="unit-hours">{{ unit.unit_hours }} minutes</div>
                                </div>

                                <!-- UNIT BODY -->
                                <div class="unit-body" *ngIf="unit.expanded">

                                    <div class="topic" *ngFor="let topic of unit.topics">
                                        <div class="topic-title-row">
                                            <span class="dot"></span>
                                            <strong>{{ topic.topic_title }}</strong>
                                        </div>

                                        <div class="ql-snow ql-view">
                                            <div class="ql-editor" [innerHTML]="topic.description"></div>
                                        </div>

                                        <!-- SUBTOPICS -->
                                        <div class="subtopic" *ngFor="let sub of topic.subtopics">
                                            <span class="sub-dot"></span>
                                            <strong>{{ sub.subtopic_title }}</strong>
                                            <div class="ql-snow ql-view">
                                                <div class="ql-editor" [innerHTML]="sub.description"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isEditingUnits">

                            <form [formGroup]="unitsForm">
                                <div formArrayName="units">

                                    <div class="unit-edit-card"
                                        *ngFor="let unitGroup of unitsArray.controls; let u = index"
                                        [formGroupName]="u">

                                        <!-- HEADER -->
                                        <div class="unit-edit-header" (click)="toggleUnit(u)">

                                            <div class="unit-title-left">
                                                <i class="bi"
                                                    [ngClass]="unitGroup.get('expanded')?.value ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
                                                <strong>Module {{ u + 1 }}</strong>
                                            </div>

                                            <button class="delete-btn small-delete" type="button"
                                                (click)="deleteUnit(u); $event.stopPropagation()">
                                                <i class="bi bi-trash"></i>
                                            </button>

                                        </div>

                                        <br>
                                        <!-- BODY -->
                                        <div class="unit-edit-body" *ngIf="unitGroup.get('expanded')?.value">

                                            <input formControlName="unit_title" placeholder="Module Title"
                                                class="edit-input" />

                                            <input formControlName="unit_hours" placeholder="Duration" type="number"
                                                class="edit-input" />

                                            <!-- TOPICS -->
                                            <div formArrayName="topics">

                                                <div class="topic-edit-card"
                                                    *ngFor="let topicGroup of getTopics(u).controls; let t = index"
                                                    [formGroupName]="t">

                                                    <div class="edit-row-header">
                                                        <strong>Topic {{ t + 1 }}</strong>
                                                        <button class="delete-btn small-delete" type="button"
                                                            (click)="deleteTopic(u, t); $event.stopPropagation()">
                                                            <i class="bi bi-trash"></i>
                                                        </button>
                                                    </div>

                                                    <input formControlName="topic_title" placeholder="Lesson Title"
                                                        class="edit-input" />

                                                    <label class="edit-label fs-6 fw-light">Lesson Description</label>
                                                    <quill-editor formControlName="description" [modules]="quillModules"
                                                        placeholder="Enter Lesson description" class="rich-editor">
                                                    </quill-editor>
                                                    <br>
                                                    <!-- SUBTOPICS -->
                                                    <div formArrayName="subtopics" class="subtopic-list">

                                                        <div class="subtopic-edit-row"
                                                            *ngFor="let subGroup of getSubtopics(u, t).controls; let s = index"
                                                            [formGroupName]="s">

                                                            <div class="edit-row-header">
                                                                <strong>Subtopic {{ s + 1 }}</strong>

                                                                <button
                                                                    *ngIf="!coursePayload.units[u].topics[t].subtopics[s]"
                                                                    class="delete-btn small-delete" type="button"
                                                                    (click)="deleteNewSubtopic(u, t, s)">
                                                                    <i class="bi bi-trash"></i>
                                                                </button>
                                                            </div>
                                                            <label class="edit-label fs-6 mt-1 fw-light">Subtopic
                                                                Title</label>
                                                            <input formControlName="subtopic_title"
                                                                placeholder="Enter Subtopic Title" class="edit-input" />

                                                            <label class="edit-label fs-6 fw-light mt-2">Subtopic
                                                                Description</label>
                                                            <quill-editor formControlName="description"
                                                                [modules]="quillModules"
                                                                placeholder="Enter Subtopic description"
                                                                class="rich-editor">
                                                            </quill-editor>
                                                        </div>

                                                        <br>
                                                        <button class="add-btn" type="button"
                                                            (click)="addSubtopic(u, t)">
                                                            + Add Subtopic
                                                        </button>
                                                    </div>
                                                </div>

                                                <div
                                                    style="display: flex; justify-content: space-between; align-items: center; margin-top: 1rem;">

                                                    <!-- LEFT: ADD TOPIC -->
                                                    <button class="add-btn mt-2" type="button" (click)="addTopic(u)">
                                                        + Add Topic
                                                    </button>

                                                    <!-- RIGHT: SAVE + CANCEL -->
                                                    <div style="display: flex; gap: 1rem;">
                                                        <button class="action-btn save" *ngIf="isEditingUnits"
                                                            [disabled]="!canSaveUnits" (click)="saveUnitsSection()">
                                                            <i class="bi bi-check2-circle"></i> Save
                                                        </button>

                                                        <button class="action-btn cancel" *ngIf="isEditingUnits"
                                                            (click)="cancelUnitsEdit()">
                                                            <i class="bi bi-x-circle"></i> Cancel
                                                        </button>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <button class="add-btn wide-btn mt-3" type="button" (click)="addUnit()">
                                + Add New Unit
                            </button>
                        </div>
                    </div>
                </div>

                <div class="course-details-card" [formGroup]="outcomesForm">

                    <!-- EDIT BUTTON -->
					 	<ng-container *hasPermission="PermissionForStudents.COURSE_UPDATE">
                    <div class="edit-btn" *ngIf="status === courseStatus.Draft && !isEditingOutcomes"
                        (click)="startOutcomesEdit()">
                        <i class="bi bi-pencil-square"></i> Edit
                    </div>
					</ng-container>

                    <!-- SAVE + CANCEL -->
                    <div class="edit-btn" *ngIf="isEditingOutcomes" style="right: 8rem;"
                        [class.disabled]="outcomesForm.invalid" (click)="saveOutcomes()">
                        <i class="bi bi-check2-circle"></i> Save
                    </div>

                    <div class="edit-btn" *ngIf="isEditingOutcomes"
                        style="right: 2rem; background:#ffe7e7; color:#c40000;" (click)="cancelOutcomesEdit()">
                        <i class="bi bi-x-circle"></i> Cancel
                    </div>
                    <div class="course-details-header">
                        <div class="course-details-icon">
                            <i class="bi bi-award-fill"></i>
                        </div>
                        <div class="course-details-title">Course Outcomes</div>
                    </div>

                    <div class="course-details-content">
                        <!-- VIEW MODE -->
                        <div *ngIf="!isEditingOutcomes">
                            <ul *ngIf="coursePayload.course_outcomes?.length; else noOutcomes">
                                <li *ngFor="let outcome of coursePayload.course_outcomes">{{ outcome }}</li>
                            </ul>
                            <ng-template #noOutcomes>
                                <p class="text-muted text-center">No outcomes added</p>
                            </ng-template>
                        </div>
                        <!-- EDIT MODE -->
                        <div *ngIf="isEditingOutcomes">
                            <label class="edit-label">Edit Outcomes</label>

                            <textarea formControlName="course_outcomes" class="edit-textarea" rows="5"
                                placeholder="Enter one outcome per line"></textarea>

                            <small class="text-danger" *ngIf="outcomesForm.get('course_outcomes')?.touched &&
                    outcomesForm.get('course_outcomes')?.invalid">
                                Minimum 1 valid outcome is required.
                            </small>
                        </div>
                    </div>
                </div>

                <div class="course-details-card" [formGroup]="textbooksForm">

                    <!-- EDIT BUTTON -->
					<ng-container *hasPermission="PermissionForStudents.COURSE_UPDATE">
                    <div class="edit-btn" *ngIf="status === courseStatus.Draft && !isEditingTextbooks"
                        (click)="isEditingTextbooks = true">
                        <i class="bi bi-pencil-square"></i> Edit
                    </div>
					</ng-container>

                    <!-- SAVE + CANCEL -->
                    <div class="edit-btn" *ngIf="isEditingTextbooks" style="right: 8rem;"
                        [class.disabled]="!canSaveTextbooks" [attr.disabled]="!canSaveTextbooks ? true : null"
                        (click)="canSaveTextbooks && saveTextbooksSection()">

                        <i class="bi bi-check2-circle"></i> Save
                    </div>


                    <div class="edit-btn" *ngIf="isEditingTextbooks"
                        style="right: 2rem; background:#ffe7e7; color:#c40000;" (click)="isEditingTextbooks = false">
                        <i class="bi bi-x-circle"></i> Cancel
                    </div>
                    <div class="course-details-header">
                        <div class="course-details-icon"><i class="bi bi-book-half"></i></div>
                        <div class="course-details-title">Textbooks</div>
                    </div>

                    <div class="course-details-content">
                        <!-- VIEW MODE -->
                        <div *ngIf="!isEditingTextbooks">
                            <div class="resource-card" *ngFor="let tb of coursePayload.textbooks; let i = index">
                                <div class="resource-name-row">
                                    <!-- <span class="resource-count">{{ i + 1 }}</span> -->
                                    <span class="resource-name">{{ tb.title }}</span>
                                </div>

                                <div class="resource-details">
                                    {{ tb.author }} | {{ tb.publisher }} | {{ tb.year }}
                                </div>
                            </div>

                            <p class="text-muted text-center" *ngIf="!coursePayload.textbooks?.length">
                                No textbooks added
                            </p>
                        </div>

                        <!-- EDIT MODE -->
                        <div *ngIf="isEditingTextbooks">

                            <div formArrayName="textbooks" *ngFor="let group of textbooksArray.controls; let i = index">

                                <div [formGroupName]="i" class="edit-form">

                                    <div class="field-group">
                                        <input formControlName="title" placeholder="Title" class="edit-input" />
                                        <div class="error-text"
                                            *ngIf="group.get('title')?.invalid && group.get('title')?.touched">
                                            Title is required
                                        </div>
                                    </div>

                                    <div class="field-group">
                                        <input formControlName="author" placeholder="Author" class="edit-input" />
                                        <div class="error-text"
                                            *ngIf="group.get('author')?.invalid && group.get('author')?.touched">
                                            Author is required
                                        </div>
                                    </div>

                                    <div class="field-group">
                                        <input formControlName="publisher" placeholder="Publisher" class="edit-input" />
                                        <div class="error-text"
                                            *ngIf="group.get('publisher')?.invalid && group.get('publisher')?.touched">
                                            Publisher is required
                                        </div>
                                    </div>

                                    <div class="field-group">
                                        <input formControlName="year" placeholder="YYYY" class="edit-input" />
                                        <div class="error-text"
                                            *ngIf="group.get('year')?.invalid && group.get('year')?.touched">

                                            <span *ngIf="group.get('year')?.errors?.['required']">
                                                Year is required
                                            </span>
                                            <span *ngIf="group.get('year')?.errors?.['pattern']">
                                                Enter a valid 4-digit year
                                            </span>
                                            <span *ngIf="group.get('year')?.errors?.['futureYear']">
                                                Year cannot be in the future
                                            </span>

                                        </div>
                                    </div>
                                    <button type="button" class="delete-btn" (click)="deleteTextbook(i)">
                                        <i class="bi bi-trash"></i>
                                    </button>


                                </div> <!-- edit-form -->

                            </div> <!-- formArrayName -->

                            <!-- ADD NEW TEXTBOOK BUTTON -->
                            <button class="add-btn mt-2" type="button" (click)="toggleAddTextbook()">
                                + Add Textbook
                            </button>


                            <!-- ADD NEW TEXTBOOK FORM -->
                            <div class="add-textbook-container" *ngIf="addTextbookVisible">
                                <form [formGroup]="textbookForm" class="textbook-form">

                                    <div class="field-group">
                                        <input formControlName="title" placeholder="Title" class="edit-input" />
                                        <div class="error-text"
                                            *ngIf="textbookForm.get('title')?.invalid && textbookForm.get('title')?.touched">
                                            Title is required
                                        </div>
                                    </div>

                                    <div class="field-group">
                                        <input formControlName="author" placeholder="Author" class="edit-input" />
                                        <div class="error-text"
                                            *ngIf="textbookForm.get('author')?.invalid && textbookForm.get('author')?.touched">
                                            Author is required
                                        </div>
                                    </div>

                                    <div class="field-group">
                                        <input formControlName="publisher" placeholder="Publisher" class="edit-input" />
                                        <div class="error-text"
                                            *ngIf="textbookForm.get('publisher')?.invalid && textbookForm.get('publisher')?.touched">
                                            Publisher is required
                                        </div>
                                    </div>

                                    <div class="field-group">
                                        <input formControlName="year" placeholder="YYYY" class="edit-input" />
                                        <div class="error-text"
                                            *ngIf="textbookForm.get('year')?.invalid && textbookForm.get('year')?.touched">
                                            Year is required
                                        </div>
                                    </div>

                                    <button type="button" class="add-btn" (click)="addTextbook()">
                                        <i class="bi bi-plus-circle"></i> Save Textbook
                                    </button>

                                </form>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="course-details-card" [formGroup]="webResourcesForm">

					<ng-container *hasPermission="PermissionForStudents.COURSE_UPDATE">
                    <div class="edit-btn" *ngIf="status === courseStatus.Draft && !isEditingWebResources"
                        (click)="isEditingWebResources = true">
                        <i class="bi bi-pencil-square"></i> Edit
                    </div>
					</ng-container>

                    <div class="edit-btn" *ngIf="isEditingWebResources" style="right: 8rem;"
                        [class.disabled]="webResourcesForm.invalid"
                        [attr.disabled]="webResourcesForm.invalid ? true : null" (click)="saveWebResourcesSection()">
                        <i class="bi bi-check2-circle"></i> Save
                    </div>



                    <div class="edit-btn" *ngIf="isEditingWebResources"
                        style="right: 2rem; background:#ffe7e7; color:#c40000;" (click)="isEditingWebResources = false">
                        <i class="bi bi-x-circle"></i> Cancel
                    </div>
                    <div class="course-details-header">
                        <div class="course-details-icon"><i class="bi bi-link-45deg"></i></div>
                        <div class="course-details-title">Web Resources</div>
                    </div>

                    <div class="course-details-content">
                        <!-- VIEW MODE -->
                        <div *ngIf="!isEditingWebResources">
                            <div class="resource-card"
                                *ngFor="let link of coursePayload.web_references_links; let i = index">
                                <div class="resource-name-row">
                                    <!-- <span class="resource-count">{{ i + 1 }}</span> -->
                                    <a [href]="link" target="_blank" class="resource-name">{{ link }}</a>
                                </div>
                            </div>
                            <p class="text-muted text-center" *ngIf="coursePayload.web_references_links.length === 0">
                                No web resources added
                            </p>
                        </div>
                        <!-- EDIT MODE -->
                        <div *ngIf="isEditingWebResources">

                            <div formArrayName="web_references_links"
                                *ngFor="let ctrl of webLinksArray.controls; let i = index" class="web-resource-row">

                                <div class="input-wrapper">

                                    <input [formControlName]="i" placeholder="Enter URL" class="edit-input" />

                                    <!-- DELETE BUTTON -->
                                    <button type="button" class="delete-btn" (click)="deleteWebResource(i)">
                                        <i class="bi bi-trash"></i>
                                    </button>
                                </div>

                                <!-- ERROR MESSAGE -->
                                <div class="error-text" *ngIf="ctrl.invalid && ctrl.touched">
                                    Invalid URL. Must start with http:// or https://
                                </div>
                            </div>

                            <!-- ADD NEW WEB RESOURCE -->
                            <button class="add-btn mt-2" type="button" (click)="addWebResource()">
                                + Add Web Resource
                            </button>
                        </div>
                    </div>
                </div>
                <div class="course-details-card">

                    <!-- EDIT BUTTON -->
					 <ng-container *hasPermission="PermissionForStudents.COURSE_UPDATE">		 
                    <div class="edit-btn" *ngIf="status === courseStatus.Draft && !isEditingCourseDocument"
                        (click)="startEditDocument()">
                        <i class="bi bi-pencil-square"></i> Edit
                    </div>
					</ng-container>

                    <!-- SAVE BUTTON -->
                    <div class="edit-btn" *ngIf="isEditingCourseDocument" style="right: 8rem;"
                        (click)="saveDocumentSection()">
                        <i class="bi bi-check2-circle"></i> Save
                    </div>

                    <!-- CANCEL BUTTON -->
                    <div class="edit-btn" *ngIf="isEditingCourseDocument"
                        style="right: 2rem; background:#ffe7e7; color:#c40000;" (click)="cancelEditDocument()">
                        <i class="bi bi-x-circle"></i> Cancel
                    </div>
                    <div class="course-details-header">
                        <div class="course-details-icon">
                            <i class="bi bi-file-earmark-text-fill"></i>
                        </div>
                        <div class="course-details-title">Course Document</div>
                    </div>

                    <div class="course-details-content">

                        <!-- VIEW MODE -->
                        <div *ngIf="!isEditingCourseDocument" class="text-center">

                            <!-- DOWNLOAD BUTTON -->
                            <button *ngIf="coursePayload.course_document" class="btn btn-outline"
                                (click)="downloadDocument()">
                                <i class="bi bi-download"></i>
                                Download Document
                            </button>

                            <p class="file-name" *ngIf="coursePayload.course_document">
                                <i class="bi bi-file-earmark-text"></i>
                                {{ getDocumentFileName() }}
                            </p>

                            <p class="text-muted" *ngIf="!coursePayload.course_document">
                                No document uploaded
                            </p>
                        </div>
                        <!-- EDIT MODE -->
                        <div *ngIf="isEditingCourseDocument">

                            <!-- Preview selected or existing file -->
                            <div class="file-preview" *ngIf="documentFileName || coursePayload.course_document">
                                <i class="bi bi-file-earmark-text"></i>
                                {{ documentFileName || getDocumentFileName() }}
                            </div>

                            <!-- INLINE FLEX + GAP -->
                            <div style="display: flex; align-items: center; gap: 1rem; margin-top: 10px;">

                                <button class="btn btn-secondary" (click)="fileInput.click()">
                                    <i class="bi bi-cloud-arrow-up"></i> Choose Document
                                </button>

                                <button class="btn btn-danger" (click)="removeDocument()"
                                    [disabled]="!(documentFileName || coursePayload.course_document)">
                                    <i class="bi bi-trash"></i> Remove Document
                                </button>

                                <input type="file" accept=".pdf,.doc,.docx" hidden #fileInput
                                    (change)="onDocumentSelect($event)">
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <div class="loader-backdrop" *ngIf="isLoadingDraft || isLoadingPublish">
                <div class="loader"></div>
            </div>
        </div>
    </div>
</ng-template>